export default "__VITE_ASSET__DESbewQt__"